export default __webpack_public_path__ + "static/media/rm.8f1df184.svg";